// extracted by mini-css-extract-plugin
export default {"ContributorFooterContainer":"ContributorFooter-module__ContributorFooterContainer--lDUwn","infoIconWrapper":"ContributorFooter-module__infoIconWrapper--Zrm0m"};